module.exports = __webpack_public_path__ + "img/intro_no.de7f0ccb.svg";